define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');

    var PrivateMessageDialogViewController = ViewController.extend({
        ControllerName: "PrivateMessageDialogViewController",

        LPViewMap: {
            dialog: ".private_message_dialog",
            closeButton: ".lpview_close_private_message_dialog",
            sendButton: ".lpview_send_private_message_button",
            textarea: ".lpview_private_message_textarea"
        },

        LPLangMap: {
            privateMessageDescription: "privateMessageDescription"
        },

        initialize: function (constructorData) {
            this.chatId = constructorData.chatId;
            this.dialogView = this.getFirstElement(this.LPViewMap.dialog);
            this.textarea = this.getFirstElement(this.LPViewMap.textarea);
            this.sendButton = this.getFirstElement(this.LPViewMap.sendButton);
            this.sendButtonEnabled = false;
            this.addClass(this.sendButton, "disabled");
        },

        events: function () {
            this.bindModel({modelPath : 'chats.' + this.chatId + '.chatInfo.state', callback : this.handleChatStateChanged});
            this.bindViewEvent({selector : this.LPViewMap.closeButton, DOMEvent : "click", callback : this.hideDialog});
            this.bindViewEvent({view : this.dialog, DOMEvent : "keyup", callback : this.keyUpPressedOnDialog});
            this.bindViewEvent({view : this.sendButton, DOMEvent : "keyup", callback : this.keyUpPressedOnSendButton});
            this.bindViewEvent({view : this.textarea, DOMEvent : "keyup", callback : this.keyUpPressedOnTextarea});
            this.bindViewEvent({view : this.textarea, DOMEvent : "input", callback : this.inputPressedOnTextarea});
        },

        render: function () {
        }
    });

    PrivateMessageDialogViewController.prototype.updateChatId = function (chatId) {
        if (this.chatId !== chatId) {
            this.unbindModel({modelPath : 'chats.' + this.chatId + '.chatInfo.state', callback : this.handleChatStateChanged});
            this.chatId = chatId;
            this.bindModel({modelPath : 'chats.' + this.chatId + '.chatInfo.state', callback : this.handleChatStateChanged});
            this.textarea.value = ''; // Clearing the content of the textarea in case we switched the focus to a different chat.
            this.hideDialog();
        }
    };

    PrivateMessageDialogViewController.prototype.showDialog = function () {
        this.lpShow();
        this.previousFocusedView = document.activeElement;
        this.focus(this.textarea);
        this.textarea.value = '';
        this.disableSendButton();
    };

    PrivateMessageDialogViewController.prototype.hideDialog = function () {
        if (this.previousFocusedView) {
            this.previousFocusedView.focus();
        }
        this.previousFocusedView = null;
        this.lpHide();
    };

    PrivateMessageDialogViewController.prototype.handleChatStateChanged = function (data) {
        if (data && data.newValue && (data.newValue === 'ended' || data.newValue === 'transferred')) {
            this.hideDialog();
        }
    };

    PrivateMessageDialogViewController.prototype.sendPrivateMessage = function () {
        var agentName = this.getModelParam("agent.agentName");
        var privateLineText = this.textarea.value.replace(/\s\s*$/, '');
        var hasHtml = lpUtils.hasHtml(privateLineText);
        if (privateLineText !== '' && privateLineText !== this.translate(this.LPLangMap.privateMessageDescription)) {
            this.textarea.value = '';
            this.modelController.addLine({
                chatId: this.chatId,
                source: "agent",
                by: agentName,
                textType: hasHtml ? "html" : "plain",
                text: privateLineText,
                time: new Date(),
                subType: "ONLY_TO_REP"
            });
        }
        this.hideDialog();
    };

    PrivateMessageDialogViewController.prototype.keyUpPressedOnSendButton = function (e) {
        var keyCode = e.which || e.keyCode;
        // Check if 'enter' or 'space' was submitted and send the text
        if (this.sendButtonEnabled && (keyCode === 13 || keyCode === 32)) {
            this.sendPrivateMessage();
        }
    };

    PrivateMessageDialogViewController.prototype.keyUpPressedOnDialog = function (e) {
        var keyCode = e.which || e.keyCode;
        if (keyCode === 27) { // ESC
            this.hideDialog();
        }
        this.stopPropagation(e);
        this.preventDefault(e);
    };
    /**
     * Catch paste & cut event, waite 200 MS (so the text will placed in box) and call keyUpPressedOnTextarea
     * We use this events to catch the mouse menu events
     * @param e - event
     */
    PrivateMessageDialogViewController.prototype.inputPressedOnTextarea = function (e) {
        var that = this;
        this.timeoutForFilter = setTimeout(function () {
            this.timeoutForFilter = null;
            that.keyUpPressedOnTextarea();
        }, 200);
    };
    PrivateMessageDialogViewController.prototype.keyUpPressedOnTextarea = function (e) {
        if (this.timeoutForFilter) {
            clearTimeout(this.timeoutForFilter);
            this.timeoutForFilter = null;
        }
        if (this.textarea.value.trim() !== '') {
            this.enableSendButton();
        } else {
            this.disableSendButton();
        }
    };

    PrivateMessageDialogViewController.prototype.enableSendButton = function () {
        if (!this.sendButtonEnabled) {
            this.removeClass(this.sendButton, "disabled");
            this.bindViewEvent({view : this.sendButton, DOMEvent : "click", callback : this.sendPrivateMessage});
            this.sendButtonEnabled = true;
        }
    };

    PrivateMessageDialogViewController.prototype.disableSendButton = function () {
        if (this.sendButtonEnabled) {
            this.addClass(this.sendButton, "disabled");
            this.unbindViewEvent({view : this.sendButton, DOMEvent : "click", callback : this.sendPrivateMessage});
            this.sendButtonEnabled = false;
        }
    };

    return PrivateMessageDialogViewController;

});
